import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import Discography from './components/Discography';
import BrickCharts from './components/BrickCharts';
import AdminInbox from './components/AdminInbox';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/discography" element={<Discography />} />
        <Route path="/brickcharts" element={<BrickCharts />} />
        <Route path="/admin" element={<AdminInbox />} />
      </Routes>
    </Router>
  );
}

export default App;
